"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const core_1 = require("@material-ui/core");
const expertsSlice_1 = require("../../../../redux/slices/expertsSlice");
const staticDataSlice_1 = require("../../../../redux/slices/staticDataSlice");
const table_1 = __importDefault(require("./table"));
require("./expertsList.scss");
const queryLogs_1 = __importDefault(require("./queryLogs"));
const tabTypes = {
    0: "experts",
    1: "services",
    2: "query-logs"
};
const parseUrl = () => {
    return window.location.href
        .split("?")[1]
        .split("&")
        .reduce((result, param) => {
        const [key, value] = param.split("=");
        result[key] = value;
        return result;
    }, {
        sub_tab: ""
    });
};
function TabPanel(props) {
    const { children, value, index } = props, other = __rest(props, ["children", "value", "index"]);
    return (react_1.default.createElement("div", Object.assign({ role: "tabpanel", hidden: value !== index, id: `simple-tabpanel-${index}`, "aria-labelledby": `simple-tab-${index}` }, other), value === index && (children)));
}
class ExpertsList extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            activeTab: 0,
        };
        this.setActiveTab = (e, val) => {
            if (history.pushState) {
                const hash = window.location.hash;
                const splitHash = hash.split("&");
                const index = splitHash.findIndex(x => x.includes("sub_tab"));
                if (index > -1) {
                    splitHash[index] = `sub_tab=${tabTypes[val]}`;
                    const url = splitHash.join("&");
                    window.history.pushState({ path: url }, '', url);
                }
            }
            this.setState({ activeTab: val });
            if (val < 2) {
                this.props.getExpertsList({ type: val });
            }
            if (val === 2) {
                this.props.getQueryLogs();
            }
        };
    }
    componentDidMount() {
        const parsedUrl = parseUrl();
        let type = 0;
        if (parsedUrl.sub_tab) {
            if (parsedUrl.sub_tab === "services") {
                type = 1;
            }
            else if (parsedUrl.sub_tab === 'query-logs') {
                type = 2;
            }
        }
        this.setState({ activeTab: type });
        if (type < 2) {
            this.props.getExpertsList({ type });
            this.props.getStates();
            this.props.getServices();
        }
        if (type === 2) {
            this.props.getQueryLogs();
        }
    }
    render() {
        const { activeTab } = this.state;
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(core_1.Tabs, { value: activeTab, onChange: this.setActiveTab, className: "admin-directory", "aria-label": "simple tabs example" },
                react_1.default.createElement(core_1.Tab, { label: "Experts ", className: "simple-tab-button", disableRipple: true }),
                react_1.default.createElement(core_1.Tab, { label: "Services", className: "simple-tab-button", disableRipple: true }),
                react_1.default.createElement(core_1.Tab, { label: "Query Logs", className: "simple-tab-button", disableRipple: true })),
            react_1.default.createElement(TabPanel, { value: activeTab, index: 0, className: "simple-tabs" },
                react_1.default.createElement(table_1.default, { type: 0 })),
            react_1.default.createElement(TabPanel, { value: activeTab, index: 1, className: "simple-tabs" },
                react_1.default.createElement(table_1.default, { type: 1 })),
            react_1.default.createElement(TabPanel, { value: activeTab, index: 2, className: "simple-tabs" },
                react_1.default.createElement(queryLogs_1.default, null))));
    }
}
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        experts: experts.list,
        count: experts.count,
        visibleCount: experts.visibleCount
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getExpertsList: (data) => dispatch(expertsSlice_1.getExpertsList(data)),
        getQueryLogs: (data) => dispatch(expertsSlice_1.getQueryLogs(data)),
        getStates: () => dispatch(staticDataSlice_1.getStates()),
        getServices: () => dispatch(expertsSlice_1.getServices()),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ExpertsList);
